import { __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import classNames from 'classnames';
import { NvTabsHeaderDropdown } from '../NvTabsHeaderDropdown/NvTabsHeaderDropdown.esm.js';
import { NvTabsHeaderStandard } from '../NvTabsHeaderStandard/NvTabsHeaderStandard.esm.js';
import { useLayout } from './NvTabsHeader.hooks.esm.js';
import styles from './NvTabsHeader.module.esm.js';

var NvTabsHeader = function (props) {
    var _a;
    var refStd = React.useRef(null);
    var refDropdown = React.useRef(null);
    var _b = useLayout(refStd, refDropdown, props.tabs), isLayoutStandard = _b.isLayoutStandard, firstRenderFinished = _b.firstRenderFinished;
    return (React.createElement("div", { className: classNames((_a = {}, _a[styles.wrapper] = !firstRenderFinished, _a)), "data-testid": "tab-header-wrapper" }, isLayoutStandard ? (React.createElement(NvTabsHeaderStandard, __assign({ ref: refStd }, props))) : (React.createElement(NvTabsHeaderDropdown, __assign({ ref: refDropdown }, props)))));
};

export { NvTabsHeader };
//# sourceMappingURL=NvTabsHeader.esm.js.map
